import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LookupState } from './lookup.state';
import { NgxsModule } from '@ngxs/store';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forFeature([LookupState])
  ]
})
export class LookupStoreModule { }
